<template>
  <div class="settlement">
    <div class="settlement_pc">
      <el-row>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="grid-content bg-purple">&nbsp;</div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="grid-content bg-purple-light">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>输入姓名、身份证号码及验证手机号信息进行查询债务信息详情</span>
            </div>
            <div>
              <el-form
                :model="form"
                class="form_box"
                :rules="rules"
                ref="ruleForm"
                v-if="!information"
                style="padding:20px"
              >
                <el-form-item label="姓 名" :label-width="formLabelWidth" prop="names">
                  <el-input v-model="form.names" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" :label-width="formLabelWidth" prop="carId">
                  <el-input v-model="form.carId" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手 机 号" :label-width="formLabelWidth" prop="phone">
                  <el-input v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-row>
                  <el-col :span="11">
                    <el-form-item label="验 证 码" prop="verification" :label-width="formLabelWidth">
                      <el-input v-model="form.verification" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label>
                      <el-button v-show="verificationStatus" @click="handleClick">点击获取验证码</el-button>
                      <el-button v-show="!verificationStatus">
                        <span>{{timer}}</span>秒后重新获取
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row> -->
            <el-form-item label="" :label-width="formLabelWidth">

               <slide-verify :l="42"
                            :r="10"
                            :w="265"
                            :h="130"
                            :imgs="puzzleImgList"
                            style="font-size: 20px;"
                            slider-text="向右滑动查询"
                            @success="onSuccess"
                            @fail="onFail"
                            @refresh="onRefresh"
                ></slide-verify>

            </el-form-item>
                

                <!-- <el-form-item :label-width="formLabelWidth">
                  <el-button type="primary" @click="submitForm('ruleForm',form)">立即查询</el-button>
                </el-form-item> -->

              </el-form>
              <div v-else style="display: flex; flex-direction: column; align-items: center;">
                <img style="padding:20px" src="./../../assets/img/img-zanwu.png" alt />
                <span>无欠款信息</span>
                <el-button style="width:200px;margin:20px" @click="again">重新查询</el-button>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
        <div class="grid-content bg-purple-light"></div>
      </el-col>
    </el-row>
    </div>
    <div class="settlement_h5">
      <div class="grid-content bg-purple-light">
            <div class="clearfix_span">
              <span>输入姓名、身份证号码及验证手机号信息进行查询债务信息详情</span>
            </div>
            <div>
            </div>
            <div>
              <el-form
                :model="form"
                class="form_box"
                :rules="rules"
                ref="ruleForm"
                v-if="!information"
                style="padding:20px"
              >
                <el-form-item label=" " :label-width="formLabelWidths" prop="names">
                  <el-input v-model="form.names" placeholder="请输入姓名" autocomplete="off" style="::placeholder { font-weight: bold; }"></el-input>
                </el-form-item>
                <el-form-item label=" " :label-width="formLabelWidths" prop="carId">
                  <el-input v-model="form.carId" placeholder="请输身份证" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label=" " :label-width="formLabelWidths" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-row>
                  <el-col :span="11">
                    <el-form-item label=" " prop="verification" :label-width="formLabelWidths">
                      <el-input v-model="form.verification" placeholder="请输入验证码" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label>
                      <el-button v-show="verificationStatus" @click="handleClick" style="padding:0.35rem">点击获取验证码</el-button>
                      <el-button v-show="!verificationStatus">
                        <span>{{timer}}</span>秒后重新获取
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row> -->

              <el-form-item label=" " :label-width="formLabelWidths" prop="phone">

                <slide-verify :l="42"
                            :r="10"
                            :w="320"
                            :h="130"
                            :imgs="puzzleImgList"
                            style="font-size: 20px;"
                            slider-text="向右滑动查询"
                            @success="onSuccess"
                            @fail="onFail"
                            @refresh="onRefresh"
                ></slide-verify>

                </el-form-item>

                <!-- <el-form-item style="text-align: center;">
                  <el-button type="primary" @click="submitForm('ruleForm',form)" style="margin: 1rem;
    padding: 0.4rem 1rem;">立即查询</el-button>
                </el-form-item> -->

              </el-form>
              <div v-else style="display: flex; flex-direction: column; align-items: center;">
                <img style="padding:20px" src="./../../assets/img/img-zanwu.png" alt />
                <span>无欠款信息</span>
                <el-button style="width:200px;margin:20px" @click="again">重新查询</el-button>
              </div>
            </div>
        </div>
    </div>
    
  </div>
</template>
<script>
import axios from "axios";
export default {

  name: 'App',

  components: {},

  data() {
    const mobileValid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    const carIdValid = (rule, value, callback) => {
      const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (value === "") {
        callback(new Error(" "));
      } else if (!p.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    const verificationValid = (rule, value, callback) => {
      const p = /^\d{6}$/;
      if (value === "") {
        callback(new Error(" "));
      } else if (!p.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {

      puzzleImgList: [

        require("@/assets/img/101.jpeg"),
        require("@/assets/img/102.jpg"),
        require("@/assets/img/103.jpeg"),
        require("@/assets/img/104.jpeg"),
        require("@/assets/img/105.jpg"),

      ],

      msg: '',

      form: {
        names: "",
        carId: "",
        phone: "",
        verification: ""
      },
      information: false,
      formLabelWidth: "70px",
      formLabelWidths: "10px",
      rules: {
        names: [
          {message: " ", trigger: "change" },
          { min: 2, max: 15, message: " ", trigger: "change" }
        ],
        phone: [{ validator: mobileValid, trigger: "change" }],
        carId: [{ validator: carIdValid, trigger: "change" }],
        verification: [
          { validator: verificationValid, trigger: "change" }
        ]
      },
      verificationStatus: true, //通过v-show控制显示获取还是倒计时
      timer: 60 //定义初始时间为60s
    };
  },
  computed: {},
  watch: {},
  methods: {

    onSuccess(){

      let that = this;

      this.submitForm('ruleForm',that.form);

    },

    onFail(){

      this.msg = ''
    },

    async handleClick() {
      let that = this;
      // that.ajaxJson({
      //   url: "/websiteManage/contentListsss?carId=421123199109266866&phone=18072879978",
      //   method: "GET",
      //   success: function(data) {
      //     if (data.code == "0000") {
      //       console.info(data)
      //     }
      //   }
      // });
      // return;
      //获取验证码
      if (
        this.form &&
        !!/^1[3456789]\d{9}$/.test(this.form.phone) &&
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.form.carId
        )
      ) {
        await axios({
          url:
            "/npl/website/getVerification?carId=" + this.form.carId + '&phone=' + this.form.phone,
          method: "GET",
          withCredentials: true
        })
          .then(function(res) {
            if (res.data.code == "0000" && res.data.data) {
              that.verificationStatus = false; //点击button改变v-show的状态
              that.timer = 60;
              let auth_timer = setInterval(() => {
                that.timer--; //递减时间
                if (that.timer <= 0) {
                  that.verificationStatus = true; //60s时间结束还原v-show状态并清除定时器
                  clearInterval(auth_timer);
                }
              }, 1000);
            } else {
              that.$message({
                message: "验证码每天不能大于三次",
                type: "error"
              });
            }
          })
          .catch(function(error) {});
      } else {
        that.$message.error("请输入正确的身份证号和手机号!");
      }
    },

    handleClose() {
      let that = this;
      // that.dialogVisible = false;
    },

    again() {
      let that = this;
      that.information = false;
    },
    // submitForm(formName, form) {
    //   let that = this;
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       that.ajaxJson({
    //         url:
    //           "/website/findInfoByCarId?carId=" +
    //           // "/websiteManage/contentLists?carId=" +
    //           form.carId +
    //           "&verification=" +
    //           form.verification +
    //           "&phone=" +
    //           form.phone,
    //         method: "GET",
    //         success: function(data) {
    //           if (data.code == "0000" && data.data == 1) {
    //             that.ajaxJson({
    //               url: "/website/authClears",
    //               // url: "/websiteManage/contentListss",
    //               data: {
    //                 carId: form.carId,
    //                 // phone: form.phone,
    //                 page: 1,
    //                 size: 10
    //               },
    //               success: function(datas) {
    //                 if (datas.code == "0000") {
    //                   that.$router.push({
    //                     name: "paymentDetail",
    //                     params: datas
    //                   }); // 只能用 name
    //                 }
    //               }
    //             });
    //           }
    //           if (data.code == "0000" && data.data == 2) {
    //             that.information = true;
    //           }
    //           if (data.code == "0000" && data.data == 3) {
    //             that.$message({
    //               message: "验证码已失效请重新获取",
    //               type: "error"
    //             });
    //           }
    //           if (data.code == "0000" && data.data == 4) {
    //             that.$message({
    //               message: "验证码有误请重新输入",
    //               type: "error"
    //             });
    //           }
    //         }
    //       });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // }

    submitForm(formName, form) {
      let that = this;

          that.ajaxJson({
            url:
              "/website/findInfoByCarId?carId=" +
              // "/websiteManage/contentLists?carId=" +
              form.carId +
              "&verification=" +
              form.phone +
              "&phone=" +
              form.phone,
            method: "GET",
            success: function(data) {
              if (data.code == "0000" && data.data == 1) {
                that.ajaxJson({
                  url: "/website/authClears",
                  // url: "/websiteManage/contentListss",
                  data: {
                    carId: form.carId,
                    // phone: form.phone,
                    page: 1,
                    size: 10
                  },
                  success: function(datas) {
                    if (datas.code == "0000") {
                      that.$router.push({
                        name: "paymentDetail",
                        params: datas
                      }); // 只能用 name
                    }
                  }
                });
              }
              if (data.code == "0000" && data.data == 2) {
                that.information = true;
              }
              if (data.code == "0000" && data.data == 3) {

                that.$message({
                  message: "当日查询次数已到达上线",
                  type: "error"
                });

                that.msg = '当日查询次数已到达上线'

              }
              if (data.code == "0000" && data.data == 4) {
                that.$message({
                  message: "验证码有误请重新输入",
                  type: "error"
                });
              }
            },
        
          });

    }

  }
};
</script>
<style>
@media screen and (min-width: 300px) and (max-width: 480px) {
  .settlement {
    height: 100%;
    background: url("../../assets/img/444.jpg") no-repeat!important;
    background-size: cover!important;
  }
  .settlement input{
    display: block;
    width: 100%!important;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .2rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
  }
 .settlement .settlement_h5{
   display: block!important;
   padding: .4rem!important;
 }
 .settlement_h5 .clearfix_span{
       display: inline-block;
    margin-bottom: .5rem;
    font-size: 0.5rem;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    text-align: left;
 }
 .settlement .settlement_pc{
   display: none!important;
 }
}
.settlement {
  height: 100%;
  background: url("../../assets/img/444.jpg") no-repeat;
  background-size: 100%;
}
.settlement .settlement_h5{
   display: none;
 }
 .settlement .settlement_pc{
   display: block;
 }
.settlement input{
  width: 60%;
}


/* 在你的全局样式文件（如：styles.css 或 app.css）中 */
.el-input__inner::placeholder {
  font-size: 19px; /* 调整为你需要的字号 */
}

</style>



// WEBPACK FOOTER //
// src/components/page/settlementCertificate.vue